import React, { useCallback, useEffect, useState, useReducer } from "react";
import "./UnitMPIGaugeChartComponent";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { GetMpiGaugeChartDataAPI } from "../../../../../../Services";
import { GaugeChart } from "./GaugeChart";
import { PercentageDifferenceMarketPrice  } from "../../../../../../Helper";
import { Spinner } from "../../../../../../Components";

export const UnitMPIGaugeChartComponent = ({
  unitId,
  marketComparison,
  activeData,
  operationType,
  parentTranslationPath,
  translationPath,
}) => {
  const { t } = useTranslation(parentTranslationPath, "Shared");
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const [isLoading, setIsLoading] = useState(false);
  const [PSIPriceWithinRange, setPSIPriceWithinRange] = useState(null);
  const reducer = (select, action) => {
    if (action.id !== "edit") return { ...select, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
  };
  const [defaultState, setDefaultState] = useState({
    minPrice: null,
    maxPrice: null,
    medianPrice: null,
    medianPricePerSqft: null,
    psiPrice: null,
    noMPIDataFoundForTheUnit: null,
    isShowChat : false , 
  });
  const [state, setState] = useReducer(reducer, {
    ...defaultState,
  });

  const [percentageDifferenceFromMarketPrice, setPercentageDifferenceFromMarketPrice] = useState(null);
  const RangeofMPIGauge = useCallback(
    (psiPrice, medianPricePerSqft  , isLessThanThreeActiveMarketListings) => {
      let areaSizeSQFt = activeData?.builtup_area_sqft
        ? Number(activeData?.builtup_area_sqft)
        : 0;
      const calculatedMedianPrice =
        areaSizeSQFt && medianPricePerSqft
          ? Number(medianPricePerSqft * areaSizeSQFt)
          : 0;
      const minimumBounded = calculatedMedianPrice * 0.5;
      const maximumBounded = calculatedMedianPrice * 1.5;
      if(!isLessThanThreeActiveMarketListings)
      {
         return {
          key: "MarketListingsAreLessThanThree",
          value: "market-listings-are-less-than-three",
        };

      }
     else  if (!psiPrice && !calculatedMedianPrice)
        return {
          key: "Insufficient data",
          value: "insufficient-data",
        };
      else if (!psiPrice)
        return {
          key: "unit-price-missing",
          value: "unit-price-missing",
        };
      else if (!calculatedMedianPrice)
        return {
          key: "market-average-unavailable",
          value: "market-average-unavailable",
        };
      else if (psiPrice > maximumBounded)
        return {
          key: "isMaximumBounded",
          value: "the-unit-price-exceeds-the-market-average-by-more-than",
        };
      else if (psiPrice < minimumBounded)
        return {
          key: "minimumBounded",
          value: "the-unit-price-is-over-lower-than-the-market-average",
        };
      return {
        key: "PSIPriceWithinRange",
        value: "PSI Price Within Range",
      };
    },
    [unitId, activeData]
  );

  const GetUnitMpiGaugeChartInfo = useCallback(async () => {
    setIsLoading(true);
    const rs = await GetMpiGaugeChartDataAPI({
      unitId: unitId,
      operationType: operationType,
    });
    if (!(rs && rs.status && rs.status !== 200)) {
      if (rs)
        setState({
          id: "edit",
          value: { ...rs, noMPIDataFoundForTheUnit: null },
        });
      setPSIPriceWithinRange(
        RangeofMPIGauge(rs?.psiPrice, rs?.medianPricePerSqft , rs?.isShowChat)
      );
       setPercentageDifferenceFromMarketPrice(
         rs?.isShowChat
           ? PercentageDifferenceMarketPrice(
               rs?.psiPrice || 0,
               rs?.medianPricePerSqft || 0,
               activeData?.builtup_area_sqft || 0
             )
           : null
       ); 
      
    } else if (rs && rs.status && rs.status === 400) {
      setState({ id: "edit", value: {
        ...defaultState,
        noMPIDataFoundForTheUnit: rs?.data,
      } });
      setPSIPriceWithinRange(null);
      setPercentageDifferenceFromMarketPrice(null)
    } else {
      setState({ id: "edit", value: defaultState });
      setPSIPriceWithinRange(null);
      setPercentageDifferenceFromMarketPrice(null);
    }

    setIsLoading(false);
  });

  useEffect(() => {
    if (unitId !== undefined && operationType !== undefined)
      GetUnitMpiGaugeChartInfo();
  }, [unitId, operationType, activeData]);

  return (
    <div className="w-100 mb-3">
      <Spinner isActive={isLoading} isAbsolute />
      {!PSIPriceWithinRange && isLoading ? (
        <div className="px-2">
          <span className="px-2 fw-bold">{t(`${translationPath}mpi`)}:</span>
          <span className="fw-bold c-primary">
            {t(`${translationPath}please-wait-data-is-loading`)}
          </span>
        </div>
      ) : (
        (PSIPriceWithinRange &&
          PSIPriceWithinRange?.key === "PSIPriceWithinRange" &&
          !isLoading && (
            <div className="d-flex-column mt-4 mb-4">
              <div className="d-flex GaugeChart">
                <GaugeChart
                  activeData={activeData}
                  minPrice={state?.minPrice || 0}
                  maxPrice={state?.maxPrice}
                  medianPricePerSqft={state?.medianPricePerSqft || 0}
                  medianPrice={
                    state?.medianPricePerSqft * activeData.builtup_area_sqft ||
                    0
                  }
                  marketComparison={marketComparison}
                  psiPrice={state?.psiPrice || 0}
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  percentageDifferenceFromMarketPrice={percentageDifferenceFromMarketPrice}
                />
              </div>
            </div>
          )) || (
          <div>
            {PSIPriceWithinRange &&
              PSIPriceWithinRange?.key !== "PSIPriceWithinRange" &&
              !isLoading && (
                <span className="px-2 d-flex-column">
                  <span className="px-2 fw-bold">
                    {t(`${translationPath}mpi`)}
                  </span>
                  <span className="fw-bold c-primary px-2">
                    {t(`${translationPath}${PSIPriceWithinRange?.value}`)}
                  </span>
                </span>
              )}
            {!PSIPriceWithinRange && !isLoading && (
              <span className="px-2 d-flex-column">
                <span className="px-2 fw-bold">
                  {t(`${translationPath}mpi`)}
                </span>
                <span className="fw-bold c-primary px-2">
                  {t(`${translationPath}${"no-mpi-data-found-for-the-unit"}`)}
                </span>
              </span>
            )}
          </div>
        )
      )}
    </div>
  );
};
